import React, { useState, useEffect } from 'react';
import { Container, Nav } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { selectAppRoles } from '../../redux/userSlice';
import BrowseTab from './BrowseTab';
import AskAITab from './AskAITab';
import AdminTab from './AdminTab';
import './KnowledgeBase.css';

const KnowledgeBase = () => {
  const [activeTab, setActiveTab] = useState('browse');
  const appRoles = useSelector(selectAppRoles) || {}; // eslint-disable-line react-hooks/exhaustive-deps
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const adminCheck = Object.values(appRoles).some(
      role => role === 'Portal Admin' || role === 'Portal SRI User'
    );
    setIsAdmin(adminCheck);
  }, [appRoles]);

  return (
    <Container fluid className="kb-container py-4 px-4">
      {/* Header */}
      <div className="d-flex align-items-center justify-content-between mb-4">
        <div>
          <h2 className="kb-title mb-1">Knowledge Base</h2>
          <p className="text-muted mb-0" style={{ fontSize: '14px' }}>
            Find answers about tax sales, bidding, redemption, and more.
          </p>
        </div>

        {/* Tab navigation */}
        <Nav variant="pills" className="kb-tabs">
          <Nav.Item>
            <Nav.Link
              active={activeTab === 'browse'}
              onClick={() => setActiveTab('browse')}
              className={activeTab === 'browse' ? 'kb-tab-active' : 'kb-tab'}
            >
              Browse
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              active={activeTab === 'ai'}
              onClick={() => setActiveTab('ai')}
              className={activeTab === 'ai' ? 'kb-tab-active' : 'kb-tab'}
            >
              Ask AI
            </Nav.Link>
          </Nav.Item>
          {isAdmin && (
            <Nav.Item>
              <Nav.Link
                active={activeTab === 'admin'}
                onClick={() => setActiveTab('admin')}
                className={activeTab === 'admin' ? 'kb-tab-admin-active' : 'kb-tab'}
              >
                Admin
              </Nav.Link>
            </Nav.Item>
          )}
        </Nav>
      </div>

      {/* Tab content */}
      {activeTab === 'browse' && <BrowseTab />}
      {activeTab === 'ai' && <AskAITab />}
      {activeTab === 'admin' && isAdmin && <AdminTab />}
    </Container>
  );
};

export default KnowledgeBase;
